import React from 'react';
import Status from '../../hooks/Status';
import errorCodes from '../errors/errorCodes';
import { Redirect } from 'react-router-dom';
import routeList from '../../routes/routeList';
import Loading from './Loading';

const ApiLoader = ({ status, children }) => {
  switch (status.status) {
    case Status.Error:
      if (status.errorCode && status.errorCode.errorCode === 'OSR-001') {
        return <Redirect to={routeList.notFound} exact />;
      }

      return (
        <div className="text-center">
          <h6>
            Przepraszamy, wystąpił błąd.
            <br />
            {status.errorCode && errorCodes[status.errorCode.errorCode] && (
              <>
                {errorCodes[status.errorCode.errorCode]}
                <br />
              </>
            )}
            <button className="btn-primary btn-txt mt-3" onClick={() => window.location.reload()}>
              Odśwież stronę
            </button>
          </h6>
        </div>
      );
    case Status.Start:
      return null;
    case Status.Loading:
    case undefined:
      return <Loading />;
    case Status.Processing:
      return <Loading />;
    case Status.Success:
      return children;
    default:
      return children;
  }
};

export default ApiLoader;
